module.exports = __webpack_public_path__ + "img/at.5ab33f74.svg";